export const selectChannels = (state) => state.Channels;

export const selectChannelsById = (state) => state.Channels.get('byId');
